import type { SiteConfig, FAQItem, DownloadFile } from '@/types';

export const siteConfig: SiteConfig = {
  name: 'KeyGoTech',
  tagline: 'Advanced Acoustic Imaging Solutions',
  url: 'https://www.keygotech.com',
  email: 'info@keygotech.com',
  phone: '+86-21-5186 0355',
  address: {
    street: 'Room C01-C05, Floor C, Building 2, City Concept, 619 Longchang Road, Yangpu District',
    city: 'Shanghai',
    country: 'China',
    zip: '200090'
  },
  social: {
    linkedin: 'https://linkedin.com/company/keygotech',
    youtube: 'https://youtube.com/keygotech',
    twitter: 'https://twitter.com/keygotech'
  }
};

export const faqData: FAQItem[] = [
  {
    question: 'What is an acoustic imager and how does it work?',
    answer: 'An acoustic imager is a device that uses an array of microphones to visualize sound sources. It works by using beamforming algorithms to analyze the time differences of sound arrival at each microphone, creating a visual overlay of sound intensity on a camera image. This allows users to "see" sound and precisely locate noise sources.',
    category: 'General'
  },

  {
    question: 'Can acoustic imagers detect partial discharge in electrical equipment?',
    answer: 'Yes, our acoustic imagers are specifically designed to detect and localize partial discharge in high-voltage equipment. Partial discharge produces characteristic ultrasonic emissions (typically 30kHz - 50kHz) that our devices can detect and visualize, helping identify potential failures before they occur.',
    category: 'Applications'
  },
  {
    question: 'What is the typical detection range for gas leaks?',
    answer: 'The detection range depends on the leak pressure and orifice size. For typical compressed air leaks at 6 bar pressure, our handheld acoustic imagers can detect leaks from 0.3m to 50m distance. The DES-C200 with its 212-channel array can detect even smaller leaks at longer distances.',
    category: 'Applications'
  },
  {
    question: 'Do you provide SDK for OEM integration?',
    answer: 'Yes, we provide comprehensive SDKs for our PCB modules and core modules. The SDK includes C/C++, Python, and C# APIs with full documentation and example code. Our engineering team also provides technical support for integration projects.',
    category: 'Products'
  },
  {
    question: 'What is the warranty period for your products?',
    answer: 'All our products come with a standard 1-2 year warranty covering manufacturing defects. Extended warranty options are available for purchase. The warranty includes free repairs and calibration during the warranty period.',
    category: 'Support'
  },
  {
    question: 'How can I request a product demonstration?',
    answer: 'You can request a product demonstration by filling out the contact form on our website or emailing us at info@keygotech.com. Our sales team will contact you to schedule a demonstration either online or at your facility, depending on your location.',
    category: 'Sales'
  },
  {
    question: 'Does SignalPad software support third-party DAQ hardware?',
    answer: 'SignalPad primarily supports our KeyDAQ series data acquisition systems for optimal performance. However, we also provide limited support for selected third-party DAQ devices. Please contact our support team for specific compatibility information.',
    category: 'Software'
  },
  {
    question: 'What training options are available?',
    answer: 'We offer comprehensive training programs including online training, on-site training at your facility, and training at our headquarters in Shanghai. Training covers product operation, application techniques, and data analysis. Contact us for training schedules and pricing.',
    category: 'Support'
  },
  {
    question: 'How do I get technical support?',
    answer: 'Technical support is available via email at support@keygotech.com or through the contact form on our website. For urgent issues, you can call our support hotline during business hours. We also offer remote diagnostic services for connected devices.',
    category: 'Support'
  }
];

export const downloadFiles: DownloadFile[] = [
  {
    id: '1',
    title: 'DES-C136 Datasheet',
    description: 'Complete technical specifications for DES-C136 handheld acoustic imager',
    category: 'Datasheets',
    filename: 'DES-C136 Mini Acoustic Imager.pdf',
    fileSize: '3.89 MB',
    fileType: 'PDF',
    date: '2024-01-15',
    version: 'v2.1',
    downloadUrl: '/downloads/DES-C136 Mini Acoustic Imager.pdf'
  },
  {
    id: '3',
    title: 'DES-T163Pad Datasheet',
    description: 'Technical specifications for DES-T163Pad tablet acoustic imager',
    category: 'Datasheets',
    filename: 'DES-T163Pad Acoustic Imager.pdf',
    fileSize: '3.51 MB',
    fileType: 'PDF',
    date: '2024-02-01',
    version: 'v1.8',
    downloadUrl: '/downloads/DES-T163Pad Acoustic Imager.pdf'
  },
  /*{
    id: '4',
    title: 'SignalPad Installer',
    description: 'Latest version of SignalPad NVH analysis software',
    category: 'Software',
    filename: 'SignalPad-Setup-v4.2.exe',
    fileSize: '285 MB',
    fileType: 'EXE',
    date: '2024-03-01',
    version: 'v4.2.0',
    downloadUrl: '/downloads/SignalPad-Setup-v4.2.exe'
  },*/
  
  /*{
    id: '6',
    title: 'KeyGo Acoustic Imager App',
    description: 'Android app for DES-M series smartphone acoustic imagers',
    category: 'Software',
    filename: 'KeyGo-Acoustic-Imager-v2.5.apk',
    fileSize: '45 MB',
    fileType: 'APK',
    date: '2024-02-15',
    version: 'v2.5.1',
    downloadUrl: '/downloads/KeyGo-Acoustic-Imager-v2.5.apk'
  },
  */

    /*
  {
    id: '7',
    title: 'O-Series SDK',
    description: 'Software development kit for O72/O140 core modules',
    category: 'Software',
    filename: 'O-Series-SDK-v1.8.zip',
    fileSize: '156 MB',
    fileType: 'ZIP',
    date: '2024-01-10',
    version: 'v1.8.0',
    downloadUrl: '/downloads/O-Series-SDK-v1.8.zip'
  },

    */
   /*
  {
    id: '8',
    title: 'USB-4228 Datasheet',
    description: 'Technical specifications for USB-4228 data acquisition system',
    category: 'Datasheets',
    filename: 'USB-4228-Datasheet.pdf',
    fileSize: '1.2 MB',
    fileType: 'PDF',
    date: '2023-12-01',
    version: 'v2.0',
    downloadUrl: '/downloads/USB-4228-Datasheet.pdf'
  },
   */
  /*
  {
    id: '9',
    title: 'KeyDAQ-8116 Datasheet',
    description: 'Technical specifications for KeyDAQ-8116 multi-channel DAQ',
    category: 'Datasheets',
    filename: 'KeyDAQ-8116-Datasheet.pdf',
    fileSize: '1.8 MB',
    fileType: 'PDF',
    date: '2024-01-05',
    version: 'v1.5',
    downloadUrl: '/downloads/KeyDAQ-8116-Datasheet.pdf'
  },*/
  /*
  {
    id: '10',
    title: 'Acoustic Imaging Applications Guide',
    description: 'Comprehensive guide to acoustic imaging applications across industries',
    category: 'Application Notes',
    filename: 'Acoustic-Imaging-Applications.pdf',
    fileSize: '8.5 MB',
    fileType: 'PDF',
    date: '2024-02-20',
    version: 'v2.0',
    downloadUrl: '/downloads/Acoustic-Imaging-Applications.pdf'
  },
  {
    id: '11',
    title: 'T144 Datasheet',
    description: 'Technical specifications for T144 high-performance acoustic camera',
    category: 'Datasheets',
    filename: 'T144-Datasheet.pdf',
    fileSize: '2.5 MB',
    fileType: 'PDF',
    date: '2024-02-01',
    version: 'v1.5',
    downloadUrl: '/downloads/T144-Datasheet.pdf'
  },
  {
    id: '12',
    title: 'High Performance Array Datasheet',
    description: 'Technical specifications for high performance microphone array',
    category: 'Datasheets',
    filename: 'High-Performance-Array.pdf',
    fileSize: '3.2 MB',
    fileType: 'PDF',
    date: '2024-01-15',
    version: 'v1.2',
    downloadUrl: '/downloads/High-Performance-Array.pdf'
  },*/
  {
    id: '13',
    title: 'ODES Series PCB Modules Datasheet',
    description: 'Technical specifications for ODES series PCB modules',
    category: 'Datasheets',
    filename: 'ODES-Series-PCB-Modules.pdf',
    fileSize: '4.04 MB',
    fileType: 'PDF',
    date: '2024-01-20',
    version: 'v1.0',
    downloadUrl: '/downloads/ODES-Series-PCB-Modules.pdf'
  },
  /*{
    id: '14',
    title: 'O-Series Core Modules Datasheet',
    description: 'Technical specifications for O72/O140 core modules',
    category: 'Datasheets',
    filename: 'O-Series-Core-Modules.pdf',
    fileSize: '2.0 MB',
    fileType: 'PDF',
    date: '2024-01-25',
    version: 'v1.3',
    downloadUrl: '/downloads/O-Series-Core-Modules.pdf'
  },
  {
    id: '15',
    title: 'F-Series Modules Datasheet',
    description: 'Technical specifications for F72/F140 series modules',
    category: 'Datasheets',
    filename: 'F-Series-Modules.pdf',
    fileSize: '1.8 MB',
    fileType: 'PDF',
    date: '2024-02-10',
    version: 'v1.1',
    downloadUrl: '/downloads/F-Series-Modules.pdf'
  },*/
  {
    id: '16',
    title: 'DES-C200 Datasheet',
    description: 'Technical specifications for DES-C200 handheld acoustic imager',
    category: 'Datasheets',
    filename: 'des-c200-Datasheet.pdf',
    fileSize: '4.23 MB',
    fileType: 'PDF',
    date: '2024-01-10',
    version: 'v1.0',
    downloadUrl: '/downloads/des-c200-Datasheet.pdf'
  },
  {
    id: '17',
    title: 'DES-T168TPT Datasheet',
    description: 'Technical specifications for DES-T168TPT fixed acoustic imager',
    category: 'Datasheets',
    filename: 'DES-T168TPT Fixed Acoustic lmager.pdf',
    fileSize: '3 MB',
    fileType: 'PDF',
    date: '2024-02-05',
    version: 'v1.0',
    downloadUrl: '/downloads/DES-T168TPT Fixed Acoustic lmager.pdf'
  },
  /*
  {
    id: '18',
    title: 'Horn Capture System Datasheet',
    description: 'Technical specifications for horn capture traffic monitoring system',
    category: 'Datasheets',
    filename: 'Horn-Capture-System.pdf',
    fileSize: '2.0 MB',
    fileType: 'PDF',
    date: '2024-01-15',
    version: 'v1.0',
    downloadUrl: '/downloads/Horn-Capture-System.pdf'
  },
  {
    id: '19',
    title: 'Revved Vehicle Capture Datasheet',
    description: 'Technical specifications for revved vehicle capture system',
    category: 'Datasheets',
    filename: 'Revved-Vehicle-Capture.pdf',
    fileSize: '2.2 MB',
    fileType: 'PDF',
    date: '2024-01-20',
    version: 'v1.0',
    downloadUrl: '/downloads/Revved-Vehicle-Capture.pdf'
  }*/
];

export const applicationAreas = [
  {
    id: 'partial-discharge',
    title: 'Partial Discharge Detection',
    shortTitle: 'Partial Discharge',
    description: 'Detect and localize partial discharge in high-voltage electrical equipment before failures occur.',
    image: '/Img/EN/000.png',
    icon: 'Zap',
    benefits: [
      'Early detection of insulation degradation',
      'Prevent costly equipment failures',
      'Reduce unplanned downtime',
      'Comply with safety regulations'
    ],
    products: ['des-c136', 'des-t163pad', 'des-c200', 'des-t168tpt']
  },
  {
    id: 'gas-leak-detection',
    title: 'Gas Leak Detection',
    shortTitle: 'Gas Leak Detection',
    description: 'Visualize and pinpoint compressed air and gas leaks to save energy and improve safety.',
    image: 'solution-industrial.jpg',
    icon: 'Wind',
    benefits: [
      'Reduce energy costs by up to 30%',
      'Improve workplace safety',
      'Quick leak localization',
      'Document leaks for maintenance'
    ],
    products: ['des-c136', 'des-c200']
  },
  {
    id: 'traffic-noise-monitoring',
    title: 'Traffic Noise Monitoring',
    shortTitle: 'Traffic Monitoring',
    description: 'Monitor and enforce traffic noise regulations with acoustic-based detection systems.',
    image: 'solution-traffic.jpg',
    icon: 'Car',
    benefits: [
      'Automated violation detection',
      '24/7 monitoring capability',
      'Video evidence recording',
      'Cloud-based management'
    ],
    products: ['horn-capture', 'revved-vehicle-capture']
  },
  {
    id: 'nvh-testing',
    title: 'NVH Testing & Analysis',
    shortTitle: 'NVH Testing',
    description: 'Comprehensive noise, vibration, and harshness testing for product development and quality control.',
    image: 'nvh-testing.png',
    icon: 'Activity',
    benefits: [
      'Complete NVH analysis workflow',
      'Advanced signal processing',
      'Automated reporting',
      'Integration with DAQ hardware'
    ],
    products: ['signalpad', 'usb-4228', 'keydaq-8116', 't144']
  }
];
